export function isIOS(): boolean {
  const ua = navigator.userAgent;
  const isAppleTouchDevice = /iPad|iPhone|iPod/.test(ua);
  // iPadOS 13+ reporta UA de desktop Mac, só dá pra distinguir pelo touch
  const isIpadOs13Plus = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  return isAppleTouchDevice || isIpadOs13Plus;
}

export function isAndroid(): boolean {
  return /Android/.test(navigator.userAgent);
}

export function isMobileDevice(): boolean {
  return isIOS() || isAndroid();
}

export function isStandalonePwa(): boolean {
  const nav = navigator as Navigator & { standalone?: boolean };
  return window.matchMedia('(display-mode: standalone)').matches || nav.standalone === true;
}

/** true quando rodando dentro do wrapper Electron (salamander-desktop) — ver electron/preload.js. */
export function isDesktopApp(): boolean {
  return !!window.salamanderDesktop?.isDesktop;
}
